import clock from '../images/clock.svg';
import diaphragm from '../images/diaphragm.svg';
import money from '../images/money.svg';
import teamwork from '../images/teamwork.svg';
import home2 from '../images/home2.png';
// Styles COmponents 
import styled from 'styled-components';
import {StyledAbout,StyledDescription,StyledImage,StyledHide} from '../styles';
// Animation
import {scrollRevealAnimation} from '../animation';
import {useScroll} from './useScroll';

const ServicesSection = () => {
    const [element,controls] = useScroll();

    return (
        <StyledServices 
            variants={scrollRevealAnimation} 
            initial='hidden' 
            ref={element}
            animate={controls}
        >
            <StyledDescription>
                <h2>High <span>quality</span> services</h2>

                <Cards>
                    <Card>
                        <div className="icon">
                            <img src={clock} alt="clock"/>
                            <h3>Efficient</h3>
                        </div>
                        <p>Lorem ipsum dolor sit amet.</p>
                    </Card>

                    <Card>
                        <div className="icon">
                            <img src={diaphragm} alt="clock"/>
                            <h3>Diaphragm</h3>
                        </div>
                        <p>Lorem ipsum dolor sit amet.</p>
                    </Card>

                    <Card>
                        <div className="icon">
                            <img src={money} alt="clock"/>
                            <h3>Affordable</h3>
                        </div>
                        <p>Lorem ipsum dolor sit amet.</p>
                    </Card>

                    <Card>
                        <div className="icon">
                            <img src={teamwork} alt="clock"/>
                            <h3>Teamwork</h3>
                        </div>
                        <p>Lorem ipsum dolor sit amet.</p>
                    </Card>
                </Cards>
            </StyledDescription>
            <StyledImage>
                <img src={home2} alt="second image"/>
            </StyledImage>
        </StyledServices>
    );
};

const StyledServices = styled(StyledAbout)`
    h2{
        padding-bottom: 5rem;
    }

    p{
        width: 70%;
        padding: 2rem 0rem 4rem 0;
    }
`;

const Cards = styled.div`
    display:flex;
    flex-wrap: wrap;

    @media(max-width : 1200px){
        justify-content:center
    }
`;

const Card = styled.div`
    flex-basis: 20rem;

    .icon{
        display:flex;
        align-items:center;

        h3{
            margin-left: 1rem;
            background:white;
            color : black;
            padding : 1rem;
        }
    }
`;

export default ServicesSection;